

















































































































import { Vue, Component, Watch } from "vue-property-decorator";
import FscSimpleCard from "@/components/Card/FscSimpleCard.vue";
import RefreshButton from "@/components/Button/RefreshButton.vue";
import Table from "@/components/Table.vue";
import Avatar from "@/components/Avatars/Avatar.vue";
import { formatStudentName } from "@/utils/NameUtil";
import DeleteModal from "@/components/Modal/DeleteModal.vue";
import TestingOrganizationsThreeChoiceModal from "@/components/Exam/TestingOrganizations/TestingOrganizationsThreeChoiceModal.vue";
import SaveButton from "@/components/Button/SaveButton.vue";
import AbortButton from "@/components/Button/AbortButton.vue";
import { namespace } from "vuex-class";
import moment from "moment/moment";
import ActionButton from "@/components/Button/ActionButton.vue";
import ConfirmTuvSyncModal from "@/components/Exam/TestingOrganizations/ConfirmTuvSyncModal.vue";
import MarkStudentAsMatchedModal from "@/components/Exam/TestingOrganizations/MarkStudentAsMatchedModal.vue";
import { TestingOrganizationsStudentMatchStatusEnum } from "@/enums/TestingOrganizationsStudentMatchStatusEnum";

const TestingOrganizationsModule = namespace("testing-organizations");

@Component({
  methods: { formatStudentName },
  components: {
    ActionButton,
    AbortButton,
    DeleteModal,
    SaveButton,
    TestingOrganizationsThreeChoiceModal,
    Avatar,
    RefreshButton,
    FscSimpleCard,
    Table,
    ConfirmTuvSyncModal,
    MarkStudentAsMatchedModal,
  },
})
export default class TestingOrganizationStudentTable extends Vue {
  @TestingOrganizationsModule.Action("filter")
  public testingOrganizationsFilter: any;

  @TestingOrganizationsModule.Action("findTestingOrganizationStudentsNoMatch")
  public findTestingOrganizationStudentsNoMatch: any;

  @TestingOrganizationsModule.Action("findTestingOrganizationStudents")
  public findTestingOrganizationStudents: any;

  @TestingOrganizationsModule.Getter("getDataList")
  public testingOrganizationsItems: any;

  @TestingOrganizationsModule.Getter("getTuevStudents")
  public items: any;

  @TestingOrganizationsModule.Action("syncTestingOrganizationStudents")
  public syncTestingOrganizationStudents: any;

  @TestingOrganizationsModule.Action("saveStudentList")
  public saveStudentList: any;

  @TestingOrganizationsModule.Action("deleteTestingOrganizationStudentPermanently")
  public deleteTestingOrganizationStudentPermanently: any;

  @TestingOrganizationsModule.Getter("getIsLoading")
  public isLoading: any;

  @TestingOrganizationsModule.Getter("getTotal")
  public totalRows: any;

  public testingOrganizations: any = [];

  public activeTestingOrganizations: any = [];

  public TestingOrganizationsStudentMatchStatusEnum = TestingOrganizationsStudentMatchStatusEnum;

  private tableFields = [
    {
      key: "name",
      label: "",
      sortable: false,
    },
    {
      key: "fetchedBirthDate",
      label: "Geburtsdatum",
      sortable: false,
    },
    {
      key: "fetchedClassName",
      label: "Beantragte Klasse",
      sortable: false,
    },
    {
      key: "fetchedId",
      label: "Rücklaufnummer",
      sortable: false,
    },
    {
      key: "fetchedClassValidUntil",
      label: "Ablaufdatum",
      sortable: false,
    },
    {
      key: "tuevSystem",
      label: "Prüforganisation",
      sortable: false,
    },
    {
      key: "studentEducationId",
      label: "Validiert",
      sortable: false,
      tdClass: "pl-3",
    },
    {
      key: "deleteBtn",
      label: "",
      sortable: false,
    },
  ];

  public formatDateTime(date: string): string {
    return moment(date).format("DD.MM.YYYY");
  }

  // local copy
  public tableItems: any[] = [];

  private selectedForDeletion: any = "";
  private selectedForMarkingAsMatched: any = null;
  protected deleteModalId = "delete-tuv-fetched-student-modal";
  protected confirmSyncModalId = "confirm-tuv-sync-modal";
  protected markStudentAsMatchedModalId = "mark-student-as-matched-modal";

  @Watch("items", { immediate: true })
  onItemsChanged(newItems: any) {
    this.tableItems = Array.isArray(newItems) ? [...newItems] : [];
  }

  get tuevSystem() {
    return this.activeTestingOrganizations[0] ?? null;
  }

  protected onDelete(id: any): void {
    this.selectedForDeletion = id;
    this.$bvModal.show(this.deleteModalId);
  }

  private softDeleteStudent(): void {
    const id = this.selectedForDeletion;
    if (!id) return;

    // remove from visible table
    this.tableItems = this.tableItems.filter((item: any) => item.id !== id);

    this.selectedForDeletion = "";
  }

  private async deleteStudentPermanently() {
    const id = this.selectedForDeletion;
    if (!id) return;

    const data = await this.deleteTestingOrganizationStudentPermanently(id);

    if (data) this.softDeleteStudent();
  }

  protected onAbort(): void {
    this.tableItems = Array.isArray(this.items) ? [...this.items] : [];
  }

  public openMarkAsMatchedConfirmationModal(student: any): void {
    this.selectedForMarkingAsMatched = student;
    this.$bvModal.show(this.markStudentAsMatchedModalId);
  }

  public markAsMatched(student: any): void {
    this.tableItems = this.tableItems.map((item: any) =>
      item.id === student.id
        ? {
            ...item,
            markedAsMatched: true,
          }
        : item
    );
  }

  protected async onSaveStudents(): Promise<void> {
    const studentList = this.tableItems
      .filter((item: any) => item.matchStatus === TestingOrganizationsStudentMatchStatusEnum.MATCHED || item.markedAsMatched)
      .map((item: any) => item.id);

    console.log(studentList);

    const successful = await this.saveStudentList(studentList);
    if (successful) {
      this.$toasted.success(this.$t("messages.operation_successful").toString());
    }
  }

  public confirmSyncStudents() {
    this.$bvModal.show(this.confirmSyncModalId);
  }

  public async syncStudents(): Promise<void> {
    if (!this.tuevSystem) return;

    await this.syncTestingOrganizationStudents({ tuevSystem: this.tuevSystem });

    // refetch list after syncing
    await this.findTestingOrganizationStudents({ tuevSystem: this.tuevSystem });
  }

  public async requestQueryNoMatch(): Promise<void> {
    await this.findTestingOrganizationStudentsNoMatch({ tuevSystem: this.tuevSystem });
  }

  public async requestQuery(): Promise<void> {
    await this.findTestingOrganizationStudents({ tuevSystem: this.tuevSystem });
  }

  // public async mounted() {
  //   await this.testingOrganizationsFilter({
  //     resource: "testing-organizations",
  //     filter: { archived: false },
  //   });
  //
  //   this.testingOrganizations = Array.isArray(this.items) ? [...this.items] : [];
  //   this.activeTestingOrganizations = this.testingOrganizations
  //     .filter((item: any) => item.tuevSystemUsername && item.tuevSystemPassword)
  //     .map((item: any) => item.tuevSystem);
  //
  //   // next line is commented out because table does the request once it is mounted
  //   // await this.findTestingOrganizationStudents({ tuevSystem: this.tuevSystem });
  // }

  public async mounted() {
    await this.testingOrganizationsFilter({
      resource: "testing-organizations",
      filter: { archived: false },
    });

    this.testingOrganizations = Array.isArray(this.testingOrganizationsItems) ? [...this.testingOrganizationsItems] : [];

    this.activeTestingOrganizations = this.testingOrganizations
      .filter((item: any) => item.tuevSystemUsername && item.tuevSystemPassword)
      .map((item: any) => item.tuevSystem);
  }
}
